import * as ROLES from '../../constants/roles'

export const isLogged = authUser => !!authUser
export const isAdminLogged = authUser => authUser && authUser.roles.includes(ROLES.ADMIN)
export const isUserLogged = authUser => authUser && authUser.roles.includes(ROLES.USER)